import { memoize } from 'lodash'

import { LOAD_RIG_STATE_OUTPUTS } from '../constants'

async function getData() {
    const response = await fetch('/services/plugin-rig-state/config/rig-state-model')

    if (!response.ok) throw new Error(response.status + ': ' + response.statusText)

    return await response.json()
}

const memoizedGetData = memoize(getData)

export default () => async dispatch => {
    try {
        const data = await memoizedGetData()
        dispatch({
            type: LOAD_RIG_STATE_OUTPUTS,
            outputs: data.outputs
        })
    } catch (e) {
        console.error('Could not load rig state outputs:', e)
    }
}
